import { History } from 'history';
import postal from 'postal';

export const NavigationType =  {
  newPage: 'NEW_PAGE',
  jobMenuSwitch: 'JOB_MENU_SWITCH',
};

let index = 1;

export function openNewPage(history:History,
  link:string,
  navigationType:string,
  metadata:any|null=null,
  afterScreenUrl: string|null = null, /* Used to make sure new screen is on stack after this url */
  params: any|null=null,
) {
  const channel = postal.channel('ifms-navigation');

  if (!!metadata) {
    history.push(link, {
      type: navigationType,
      index: index++,
      afterScreenUrl,
      params: {...params},
    });
  
    // Duplicate push so we can handle back button in correct way
    history.push(link, {
      type: navigationType,
      index: index++,
      afterScreenUrl,
      metadata: { ...metadata },
      params: {...params},
    });

  } else {
    history.push(link, {
      type: navigationType,
      index: index++,
      afterScreenUrl,
      metadata: { ...metadata },
      params: {...params},
    });
  
    // Duplicate push so we can handle back button in correct way
    history.push(link, {
      type: navigationType,
      afterScreenUrl,
      index: index++,
      params: {...params},
    });
  }

  channel.publish('ifms-navigation.urlChange', link);
}
